<template>
  <div v-if="vIf" v-show="vShow" :style="item.style || {}" class="schema-form__layout rel">
    <!-- 表单项分组 -->
    <div v-if="item.type === 'group'" class="schema-form__group">
      <!-- @click="item.expanded = !item.expanded" -->
      <div class="schema-form__group-header">
        <div class="schema-form__group-label fs14 flex1">
          {{ item.label }}
          <span class="gray9">{{ item.subLabel }}</span>
        </div>
        <!-- <div class="expand-trigger" :class="{ expanded: item.expanded }"></div> -->
      </div>
      <div v-show="item.expanded" class="schema-form__group-content">
        <SchemaFormLayout
          v-for="child in item.children"
          :key="child.name"
          :parent="item"
          :item="child"
          :schema="schema"
          :values="values"
          @component-event="onComponentEvent"
        />
      </div>
    </div>
    <!-- inline 属性 -->
    <div v-else-if="item.type === 'inline'" class="schema-form__inline" :style="item.style || {}">
      <div
        v-if="item.label"
        class="schema-form__label"
        :style="{
          width: item.labelWidth || schema.labelWidth,
          ...(item.labelStyle || {}),
        }"
      >
        {{ item.label }}
      </div>
      <SchemaFormLayout
        v-for="child in item.children"
        :key="child.name"
        :parent="item"
        :item="child"
        :schema="schema"
        :values="values"
        @component-event="onComponentEvent"
      />
    </div>
    <!-- abstract-group 属性 -->
    <div v-else-if="item.type === 'abstract-group'" class="schema-form__abstract-group" :style="item.style || {}">
      <SchemaFormLayout
        v-for="child in item.children"
        :key="child.name"
        :parent="item"
        :item="child"
        :schema="schema"
        :values="values"
        @component-event="onComponentEvent"
      />
    </div>
    <!-- 隐藏元素 -->
    <template v-else-if="item.type === 'hidden'">
      <SchemaFormItem
        :key="item.name"
        style="display: none"
        :item="item"
        :schema="schema"
        :parent="parent"
        :values="values"
        @component-event="onComponentEvent"
      />
    </template>
    <!-- block 属性 -->
    <template v-else>
      <SchemaFormItem
        :key="item.name"
        :item="item"
        :schema="schema"
        :parent="parent"
        :values="values"
        @component-event="onComponentEvent"
      />
    </template>
  </div>
</template>
<script>
import SchemaFormItem from './SchemaFormItem.vue';
import { defineComponent, computed } from 'vue';
import { get } from 'lodash-es';

export default defineComponent({
  name: 'SchemaFormLayout',
  components: { SchemaFormItem },
  props: {
    schema: { type: Object, default: () => ({}) },
    parent: { type: Object, default: () => ({}) },
    item: { type: Object, default: () => ({}) },
    values: { type: Object, default: () => ({}) },
  },
  emits: ['component-event'],
  setup(props, { emit }) {
    function check(k, v) {
      const realValue = get(props.values, k);
      if (
        typeof v === 'string' &&
        (v.startsWith('>') || v.startsWith('<') || v.startsWith('==') || v.startsWith('!='))
      ) {
        const exp = `return ${realValue === '' ? JSON.stringify('') : realValue} ${v}`;
        const result = new Function(exp)();
        // console.log(1, { exp, result });
        return result;
      } else {
        return realValue === v;
      }
    }
    const vIf = computed(() => {
      if ('if' in props.item) {
        if (typeof props.item.if === 'function') {
          return props.item.if(props.values);
        }
        const ifType = props.item.ifType || 'and';
        return Reflect.ownKeys(props.item.if)[ifType === 'and' ? 'every' : 'some'](conditionKey => {
          return check(conditionKey, props.item.if[conditionKey]);
        });
      } else {
        return true;
      }
    });
    const vShow = computed(() => {
      if ('show' in props.item) {
        if (typeof props.item.show === 'function') {
          return props.item.show(props.values);
        }
        const showType = props.item.showType || 'and';
        return Reflect.ownKeys(props.item.show)[showType === 'and' ? 'every' : 'some'](conditionKey => {
          return check(conditionKey, props.item.show[conditionKey]);
        });
      } else {
        return true;
      }
    });

    const onComponentEvent = v => emit('component-event', v);

    return {
      vShow,
      vIf,
      onComponentEvent,
    };
  },
});
</script>
<style lang="less" scoped>
.schema-form__group {
  margin: 5px 0;
}
.schema-form__inline {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.schema-form__group-header {
  margin: 16px -16px 0;
  display: flex;
  align-items: center;
  padding: 16px 16px 0;
  border-top: 2px solid rgb(224, 230, 237);
  // cursor: pointer;
  user-select: none;
}
.schema-form__group-label {
  font-weight: bold;
}

.expand-trigger {
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-left-color: #999;
  transition: transform 0.3s;
  transform-origin: 20% 50%;
  &.expanded {
    transform: rotate(90deg);
  }
}
</style>
